module.exports = __webpack_public_path__ + "static/media/row-selected.0ed3505f.svg";